import React, { useEffect } from 'react';

import { Container } from 'reactstrap';
import Testimonials from '../../components/Testimonials';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <section className="page-section">
            <Container>
                <div className="bg-img">
                    <h2 className="pageTitle">About</h2>
                </div>
                <p className="text-center">
                    Federalist Pig is a regional American BBQ restaurant drawing inspiration from
                    all across the south and the world. We don't like to get boxed into a specific
                    regional style as we love it all. In addition to the fan favorites of ribs,
                    wings, brisket and sausage, we specialize in creative sandwiches using all of
                    our BBQ meats with flavorful sauces and condiments.
                </p>
                <Testimonials titleParagraph={'Members of ChefFood'} />
            </Container>
        </section>
    );
};

export default About;
